var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.43L7.602 8l-.69-2.96L9.21 3.048l-3.028-.26L5 0 3.817 2.787.79 3.048 3.084 5.04 2.398 8 5 6.43z",
    fill: "#D2D2D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default "/_next/static/images/3f4e036f5f416d09305fc0c153b2b52e.svg";
export { ForwardRef as ReactComponent };